import styled from "styled-components"

const ImageCaption = styled.div`
    margin: 0 auto;
    margin-bottom: 3rem;
    color: var(--text-color);
    font-size: 1.5rem;
    font-family: var(--font-sans-serif);
    line-height: 2.1rem;

`
export default ImageCaption